import React from 'react';
import PropTypes from 'prop-types';

const Finished = ({ correct }) => <div>Finished! { 50 / correct } %</div>;

Finished.propTypes = {
  correct: PropTypes.number.isRequired,
};

export default Finished;



// WEBPACK FOOTER //
// ./src/components/Finished.js